import { Button } from "@/components/ui/button";
import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Link } from "react-router-dom";

export function CookieConsentBanner() {
  const {
    consent,
    acceptAll,
    rejectAll,
    openPreferences,
  } = useCookieConsent();

  // Already decided: don't show
  if (consent !== null) return null;

  const handleAcceptAll = () => {
    acceptAll();
  };

  const handleRejectAll = () => {
    rejectAll();
  };

  const handleManage = () => {
    openPreferences();
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[100] border-t border-border/60 bg-card/95 backdrop-blur-md shadow-[0_-4px_24px_rgba(0,0,0,0.08)] dark:shadow-[0_-4px_24px_rgba(0,0,0,0.3)]"
    >
      <div className="container mx-auto px-4 py-4 md:py-5 max-w-4xl">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-sm text-muted-foreground flex-1">
            We use cookies for essential functionality, analytics, and marketing.
            You can accept all, reject non-essential, or{" "}
            <button
              type="button"
              onClick={handleManage}
              className="text-primary hover:underline font-medium focus:outline-none focus:ring-2 focus:ring-ring rounded"
            >
              manage preferences
            </button>
            . See our{" "}
            <Link to="/cookies" className="text-primary hover:underline">
              Cookie policy
            </Link>
            .
          </p>
          <div className="flex flex-wrap items-center gap-2 shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={handleRejectAll}
              aria-label="Reject all non-essential cookies"
            >
              Rifiuta tutti
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleManage}
              aria-label="Manage cookie preferences"
            >
              Gestisci
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={handleAcceptAll}
              aria-label="Accept all cookies"
            >
              Accetta tutti
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
